var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcNoShow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19824_10447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5359 22.0059H4.03589M20.5359 24.8184V16.7559H4.03589V24.8184M10.2972 5.39214L14.2747 9.36963M14.2746 5.39214L10.2971 9.36963M12.2859 15.337C12.2859 14.1439 13.0395 13.0829 14.1642 12.6846C16.3472 11.9115 17.9109 9.82877 17.9109 7.38086C17.9109 4.27427 15.3925 1.75586 12.2859 1.75586C9.17929 1.75586 6.66089 4.27427 6.66089 7.38086C6.66089 9.82877 8.22455 11.9115 10.4076 12.6846C11.5322 13.0829 12.2859 14.1439 12.2859 15.337ZM12.2859 15.337V16.7559",
    stroke: "#232F3E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19824_10447"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.285889 0.818359)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNoShow);
export default __webpack_public_path__ + "static/media/ic_no_show.235255a4de6c49297f479cb7f7c74868.svg";
export { ForwardRef as ReactComponent };